import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.css';
interface Props {
  label: string;
  checked?: boolean;
  disabled?: boolean;
  black?: boolean;
  denim?: boolean;
  highlight?: boolean;
  className?: string;
  onChange?: (checked: boolean) => void;
}

const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  ({ label, className = '', checked = false, highlight = false, onChange, disabled = false, black, denim }, ref) => {
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      onChange && onChange(event.target.checked);
    };

    return (
      <div className={clsx(className, 'group relative pr-3 sm:pr-10 last:pr-0 font-openSans')}>
        <label className="flex items-center cursor-pointer">
          <div
            className={clsx(
              'flex items-center justify-center w-5 h-5 rounded-full border-solid border',
              styles.wrapper
            )}
          >
            <div
              className={clsx('w-3 h-3 rounded-full', {
                [styles.checked]: checked,
              })}
              aria-hidden="true"
            />
          </div>

          <span
            className={clsx(`pl-2 flex items-center cursor-pointer font-openSans flex-1 text-black`, styles.label, {
              [styles.labelChecked]: checked,
            })}
          >
            {label}
            {highlight && (
              <span className="bg-red-100 text-red-800 text-sm font-medium ml-2 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900">
                New
              </span>
            )}
          </span>

          <input
            type="radio"
            disabled={disabled}
            onChange={handleOnChange}
            checked={checked}
            className="cursor-pointer absolute opacity-0 h-0 w-0"
            ref={ref}
          />
        </label>
      </div>
    );
  }
);

RadioButton.displayName = 'RadioButton';

export default RadioButton;
